import { Component, OnInit,Input } from '@angular/core';
import {  QuestionAnswer, Question, OptionsInfo, QuestionType, ValidationData, SelectedQuestionData, qTypes } from 'src/app/shared/components/page/page.model';

@Component({
  selector: 'app-grid-input',
  templateUrl: './grid.component.html',
  styleUrls: ['./grid.component.scss']
,  standalone: false
})
export class GridComponent implements OnInit {
  @Input() pageData: Question[] = [];
  @Input() isEditing: boolean = false;

  ngOnInit() {
    //This blank function is mandatory.
  }

}
